"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const vuex_1 = tslib_1.__importDefault(require("vuex"));
const heros_json_1 = tslib_1.__importDefault(require("../../core/fixtures/heros.json"));
const lodash_1 = require("lodash");
vue_1.default.use(vuex_1.default);
function data2myData(data) {
    if (!data)
        return {};
    return { no: data.id, max_hp: data.hp, atk: data.atk, def: data.def, spd: data.spd, cri: data.cri, cri_dmg: data.cri_dmg, eft_hit: 0, eft_res: 0, waitInput: false, index: 0 };
}
exports.default = new vuex_1.default.Store({
    state: {
        team0: lodash_1.sampleSize(heros_json_1.default, 5).map(data => Object.assign({ teamId: 0, waitInput: false }, data2myData(data))),
        team1: lodash_1.sampleSize(heros_json_1.default, 5).map(data => Object.assign({ teamId: 1, waitInput: false }, data2myData(data))),
    },
    mutations: {
        UPDATE_TEAM_MEMBER(state, data) {
            const hero = heros_json_1.default.find(d => d.id === data.no);
            if (data.teamId === 0) {
                vue_1.default.set(state.team0, data.index, Object.assign({ teamId: 0, waitInput: false }, state.team0[data.index], data2myData(hero), data));
            }
            if (data.teamId === 1) {
                vue_1.default.set(state.team1, data.index, Object.assign({ teamId: 1, waitInput: false }, state.team1[data.index], data2myData(hero), data));
            }
        }
    },
    actions: {},
    modules: {},
});
